export default
{
    legend: {
        layout: 'horizontal', align:'center', verticalAlign: 'bottom'

    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'column',
        animation: false,
        height: '500px',
    },
    title: {
        text: 'História úhrnu zrážok za posledné 3 dni',
        style: {color: '#2196f3',  fontSize:'13px'}

    },
    subtitle: {
        text: '',
        style: {color: '#2196f3',  fontSize:'12px'}
    },
    tooltip: {
        valueSuffix: ' mm',
    },
    xAxis: {
        title: {text: null},
        type: 'datetime',
        tickInterval: 6 * 60 * 60 * 1000,
        minorTickInterval: 24 * 60 * 60 * 1000,
        minorTickColor: '#000000',
        minorGridLineColor: '#000000',
        dateTimeLabelFormats: {day: '%e. %B'},
        tickWidth: 2, gridLineWidth: 1,
        labels: {style: {fontSize: '10px'}, rotation: 270, x: 3, y: 12},
        gridLineDashStyle: 'Dot',
        lineWidth: 2,

    },
    yAxis: [{
        opposite:true,
        title: {text: null},
        min: 0,
        minorGridLineWidth: 0,
        gridLineWidth: 1,
        alternateGridColor: null,
        lineWidth: 2,
        tooltip: {valueSuffix: ' mm'},
        gridLineDashStyle: 'Dot',
        minTickInterval: 1,
        tickInterval: 1

    }],
    plotOptions: {
        column: {
            borderWidth: 0,
            animation: false,
            marker: {enabled: false},
            enableMouseTracking: true,
            tooltip: {
                dateTimeLabelFormats: {
                    hour: '%e.%B.%Y %H:%M',
                }
            }
        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [{id:'z', name:'1 hod. úhrn zrážok', showInLegend: false, color:'#307CDA', data:[]}]
}